<div *ngIf="copyrights?.copy" id="copyright" [style]="getCopyrightsStyle()">
  {{copyrights.copy}}
</div>